import { AlertPhone } from '../types'

export function isAlertPhoneVerified(alertPhone: AlertPhone): boolean {
  return alertPhone.phoneVerifiedAt !== null
}
